<template>
  <div class="container">
    <nav class="add-navigation my-3">
      <div class="right-wrapprr my-2">
        <search-input
          class="search-input"
          type="text"
          v-model="Searchreseller"
          placeholder="Search for reseller"
        />
      </div>
      <div class="buttons-wrapper my-2">
        <div class="primary-button">
          <primary-button class="white-space-nowrap"
            @click.native="$router.push({name: 'system-admin-add-reseller'})"
          >Add Reseller</primary-button>
        </div>
      </div>
    </nav>
    <table class="Invoice_table">
      <thead>
        <tr class="Invoice_table_header">
          <th>Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-if="resellers.length > 0" v-for="(item, k) in resellers">
          <tr
            class="line"
            :key="k"
            @click="$router.push({name: 'system-admin-reseller', params: {id: item.resellerId}})"
          >
            <th class="creadted_by">
              <img class="popup_image" :src="item.path" alt />
              <div class="info">
                <div class="name">{{item.resellerName}}</div>
                <div class="other">
                  <div>
                    <p>Member since:</p>
                    <span>{{item.createdOn}}</span>
                  </div>
                  <div>
                    <p>Balance:</p>
                    <span v-if="item.balance">${{item.balance}}</span>
                  </div>
                </div>
              </div>
            </th>
            <th class="icon-right d-flex flex-column-reverse flex-sm-row align-items-center justify-content-center h-100">
              <svg
                @click="$router.push({name: 'system-admin-edit-reseller', params: {id: item.resellerId}})"
                class="svg-grey edit"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                  id="path-1"
                />
              </svg>
              <svg
                @click="deleteReseller(item.resellerId)"
                class="svg-grey delete ml-sm-3"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                  id="path-1"
                />
              </svg>
              <div class="dropdown-container mb-2 mb-sm-0">
                <b-dropdown variant="link" size="lg" no-caret>
                  <template slot="button-content" >
                    <span class="popup_cta mr-0">...</span>
                  </template>
                  <b-dropdown-item @click="$router.push({name: 'system-admin-resellers-payment-history', params: {id: reseller.resellerId}})">Payment History</b-dropdown-item>
                  <b-dropdown-item @click="$router.push({name: 'system-admin-resellers-invoice-history', params: {id: item.resellerId}})">Invoice History</b-dropdown-item>
                  <b-dropdown-item @click="$router.push({name: 'system-admin-resellers-transaction-history', params: {id: item.resellerId}})">Transaction History</b-dropdown-item>
                  <b-dropdown-item @click="$router.push({name: 'system-admin-add-manual-payment-reseller', params: {id: item.resellerId}})">Add Mannual payment</b-dropdown-item>
                </b-dropdown>
              </div>
            </th>
          </tr>
          <tr class="speace" v-if="item.resellerId != reseller.resellerId"></tr>
          <tr class="detail" v-if="item.resellerId == reseller.resellerId" :key="item.resellerId">
            <th colspan="2">
              <div class="detail-container">
                  <div class="row w-100">
                    <div class="col-md-6 col-12 d-flex flex-column">
                      <div class="d-flex align-items-center mb-3">
                        <span class="detail-title">Username:</span>
                        <span>{{reseller.resellerName}}</span>
                      </div>
                      <div class="d-flex align-items-center mb-3">
                        <span class="detail-title">Email:</span>
                        <span class="email word-break">{{reseller.email}}</span>
                      </div>
                      <div class="d-flex align-items-center mb-3">
                        <span class="detail-title word-break">Phone Number:</span>
                        <span>{{reseller.phone}}</span>
                      </div>
                    </div>
                    <div class="col-md-6 col-12 d-flex flex-column">
                      <div class="d-flex align-items-center mb-3">
                        <span class="detail-title">Clients:</span>
                        <span>{{reseller.clients}}</span>
                      </div>
                      <div class="d-flex align-items-center mb-3">
                        <span class="detail-title">Address:</span>
                        <span class="word-break">{{reseller.address}}</span>
                      </div>
                    </div>
                </div>
              </div>
            </th>
          </tr>
          <tr class="speace" v-if="item.resellerId == reseller.resellerId"></tr>
          <tr class="speace" v-if="item.resellerId == reseller.resellerId"></tr>
        </template>
      </tbody>
    </table>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :perPage="per_page"
        :qnt="resellers.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue")
  },
  data: () => ({
    showDropDown: false,
    resellers: [],
    Page: 0,
    TotalPages: null,
    Searchreseller: "",
    reseller: [],
    active: false,
    per_page: 10
  }),
  mounted() {
    console.log("mounted");
    this.getResellersList();
  },
  created() {
    this.getResellersList();
  },
  //   beforeRouteUpdate (to, from, next) {
  //     console.log("to --> ", to.params.id);
  //     this.getResellersList();

  //     next();
  //   },
  watch: {
    "$route.params.id": function(id) {
      this.getResellersList();
    },
    Searchreseller(val) {
      this.getResellersList()
    }
  },
  methods: {
    changePage(page) {
      this.Page = page;
      this.getResellersList();
    },
    getResellersList() {
      this.$store
        .dispatch("GetResellerList", {
          page: this.Page,
          reseller_name: this.Searchreseller,
        })
        .then(res => {
          this.Total = res.total;
          this.TotalPages = res.total / res.per_page;
          this.resellers = res.items.map(this.transformResellers);
          if (this.Page == 0) {
            this.resellers = this.resellers.filter(i => {
              if (i.resellerId === this.$route.params.id) {
                this.reseller = i;
                return false;
              }
              return true;
            });
            this.resellers.unshift(this.reseller);
          }
        });
    },
    getReseller() {
      this.$store.dispatch("GetReseller", this.$route.params.id).then(res => {
        console.log("res GetReseller", res);
        this.reseller = this.transformResellers(res, 0);
        if (this.Page == 0) {
          this.resellers = this.resellers.filter(
            i => i.resellerId === this.$route.params.id
          );
          console.log("this.resellers", this.resellers);
          this.resellers.unshift(this.reseller);
          console.log("this.resellers 222222", this.resellers);
        }
      });
    },
    transformResellers(i, k) {
      return {
        clients: i.clients_count,
        balance: "",
        createdOn: format(i.created_on, "D MMM YYYY"),
        resellerId: i.reseller_uuid,
        resellerName: i.reseller_name,
        email: i.contact ? i.contact.email : "",
        phone: i.contact ? i.contact.phone : "",
        address: i.contact ? i.contact.address : "",
        path: i.contact
          ? i.contact.logo_file_uuid
            ? `http://88.198.219.62/api_smsc/v1/file/${i.contact.logo_file_uuid}`
            : null
          : null
      };
    },
    changeActiveReseller() {},
    deleteReseller(resellerId) {
      console.log("resellerId", resellerId);
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this reseller!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("DeleteReseller", resellerId)
            .then(res => {
              console.log("res--->", res);
              this.getResellersList();
              this.$swal(
                "Deleted!",
                "Your reseller has been deleted.",
                "success"
              );
            })
            .catch(err => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .right-wrapprr {
      display: flex;
      align-items: center;
      width: fit-content;
      .search-input {
        height: 40px;
        width: 100%;
        background-color: #ffffff;
      }
      .selects-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .filter_by {
          //height: 20px;
          color: #55616e;
          font-weight: normal;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          padding: 1rem 0 1rem 2rem;
        }
        .company {
          height: 40px;
          padding: 0 0 0 10px;
          margin-bottom: 10px;
          color: #55616e;
          font-weight: normal;
        }
        .choose-company {
          height: 40px;
          padding: 0 0 0 10px;
          margin-bottom: 10px;
          color: #55616e;
          font-weight: normal;
        }
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
      }
    }
  }
}
table.Invoice_table {
  width: 100%;
}
table thead tr {
  background: #f8f9fe;
  text-align: left;;
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 12px 0;
  font-size: 14px;
  line-height: 20px;
}
table {
  border-collapse: collapse;
  border-spacing: 0 0 0 10px;
  background: #f8f9fe;
}
.Invoice_table_popup {
  float: right;
  width: 75px;
}
.Invoice_table_header th {
  color: #212b36;
  font-family: "Helvetica Neue";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  padding: 1rem 0 1rem 2rem;
}
.popup_content {
  display: none;
}
.btn-link {
  bottom: 10px;
  color: black;
}
tbody tr {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 10px;
  text-align: left;
}
tbody th.icon-right {
  float: right;

  .dropdown-container {
    height: 30px;
    padding-right: 4px;
    margin-top: -14px;
    .popup_cta {
      cursor: pointer;
      color: #55616e;
    }
    button {
      padding: 0;
      margin: 0;
    }
  }
}
.icon-right .svg-grey {
  fill: #55616e;
  height: 30px;
  width: 30px;
}
.icon-right span {
  margin-right: 15px;
}
table th:first-child {
  padding-left: 20px;
}
tbody th.creadted_by {
  padding: 1rem;
  width: 100%;
  .popup_image {
    height: 60px;
    width: 60px;
    background-size: 30px 0px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 15px;
  }
  .info {
    vertical-align: top;
    display: inline-block;
    .name {
      width: 100%;
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
    }
    .other {
      justify-content: space-between;
      div {
        display: inline-flex;
        padding-right: 30px;
      }
      p {
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        margin-right: 5px;
        margin-bottom: 0 !important;
      }
      span {
        height: 25px;
        color: #000000;
        font-size: 14px;
        line-height: 25px;
      }
    }
  }
}
.speace {
  height: 10px;
  box-shadow: inset 0 0 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 0px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 0 0 0 #f0f1fa;
}
.detail {
  .detail-container {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    p {
      margin-bottom: 1rem !important;
    }
    .col {
      width: 100%;
      padding: 0;
      .col-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .col-head {
          width: 30%;
          padding-left: 15px;
          padding-right: 0;
          p {
            width: 100px;
            color: #55616e;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
            margin-bottom: 5px;
          }
        }
        .col-value {
          width: 70%;
          padding-left: 15px;
          padding-right: 0;
          div {
            height: 25px;
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
            margin-top: 0;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}
tbody th.member_since {
  padding: 7px 0 7px 0;
  width: 150px;
}
tbody th .did {
  font-size: 12px;
  width: 86px;
  height: 24px;
  padding-top: 0px;
}
tbody th.method {
  width: 110px;
  color: #55616e;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 25px;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
}
th.reseller_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 25px;
}

th.reseller_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}
.white-space-nowrap {
  white-space: nowrap !important;
}

  .detail-title {
    min-width: 115px;
    white-space: nowrap;
  }

  .break-word {
    word-break: break-all;
  }
</style>

